import { ITDisplayPrice } from '../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/Components/Displays'
import { ITCheckboxProps } from '../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/Components/Inputs'
import { RowData } from '../../../../../../../../baseComponents/TwinTable/types'
import Checkbox from '../../../../../../../../forms/Checkbox'
import { OrderInputCalendar, OrderRectangularInputSmall } from '../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderTable/TableComponents/Inputs'
import { DictionaryComponents } from '../../../../../../../../utils/globals/types'

 interface RenderExtraPaymentDataProps {
    allRowData: RowData
 }

export const RenderExtraPaymentDataRemittances: React.FC<RenderExtraPaymentDataProps> = ({ allRowData }) => {
    let value = ''
    if (allRowData?.['PayTCopy.new_extra_payment_data']?.iban){
        const { name, iban } = allRowData['PayTCopy.new_extra_payment_data']
        value = name + ' - ' + iban
    } else if (allRowData?.['PayTCopy.new_extra_payment_data']?.value){
        value = allRowData?.['PayTCopy.new_extra_payment_data']?.value
    }
    return (<div>{value}</div>)
}

interface SelectedPaymentMethodCheckboxProps extends ITCheckboxProps {
    readOnly?: boolean
}
const SelectedPaymentMethodCheckbox: React.FC<SelectedPaymentMethodCheckboxProps> = ({ value, onChange, readOnly }) => {
    return <Checkbox label={''} checked={value === true as any} onChange={onChange} readOnly={readOnly} />
}

export const selectedPaymentMethodComponentsRemittance: DictionaryComponents = {
    ITInputCalendar: OrderInputCalendar,
    ITRectangularInput: OrderRectangularInputSmall,
    ITDisplayPrice: ITDisplayPrice,
    CheckboxComponent: SelectedPaymentMethodCheckbox,
}
